export default __webpack_public_path__ + "static/ar_background-37077189c06cc275861d4ab71de6380d.webp";